<template>
  <div class="parent">
    <div class="header bg-white border-bottom border-outline-color py-1">
      <!-- ノッチ対応用DOM -->
      <div class="header__notch"></div>
      <div
        class="header__content position-relative d-flex justify-content-center align-items-center"
      >
        <!-- 左slot <template v-slot:left>で記述 -->
        <div class="header__left-slot text-left">
          <slot name="left" />
        </div>
        <!-- 中心slot -->
        <div class="header__center-slot">
          <h1 class="text-black text-size-17 text-weight-600 text-center">
            <slot />
          </h1>
        </div>
        <!-- 右slot <template v-slot:right>で記述 -->
        <div class="header__right-slot text-right">
          <slot name="right" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  position: fixed;
  left: 0;
  z-index: 100;
  width: 100%;

  &__content {
    min-height: 40px;
  }

  &__left-slot {
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
  }

  &__right-slot {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
  }

  &__notch {
    height: env(safe-area-inset-top, 0);
  }
}

.parent {
  top: 0;
  padding-bottom: calc(env(safe-area-inset-top, 0px) + 49px);
}
</style>
